import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18, default as _styled19, default as _styled20, default as _styled21, default as _styled22, default as _styled23, default as _styled24, default as _styled25, default as _styled26, default as _styled27 } from "styled-components";
import * as RadixAccordion from "@radix-ui/react-accordion";
import React from "react";
import { type Mode, type Theme, getThemeStyle } from "~/features/ui/get-theme-style";
import { specIcons, translations } from "~/features/blocks/inventory/hardware-comparison-table/utils";
import { Icon } from "~/features/ui/icon";
import { useLocale } from "~/features/i18n/use-locale";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
import { getSpecValue, type HardwareComparisonProduct, type HardwareComparisonRow } from "~/features/blocks/inventory/hardware-comparison-table";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import CaretDown from "~/public/icons/caret-down.svg";
import ArrowRight from "~/public/icons/arrow-right.svg";
import Download from "~/public/icons/download.svg";
function ProductLine(props: {
  product: HardwareComparisonProduct;
  mode: Mode;
  theme: Theme;
  rowKey: string | undefined;
}) {
  const themeStyle = getThemeStyle({
    mode: props.mode,
    theme: props.theme
  });
  const value = getSpecValue(props.product, props.rowKey);
  return <_StyledLi>
      <_StyledAsset asset={props.product.productImage as AssetProps["asset"]} imageProps={{
      width: 100,
      ratio: "1/1"
    }} />
      <h3>{props.product.title}</h3>
      <_StyledP $_css={[{
      "marginLeft": "auto",
      "textAlign": "right",
      "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
      "fontSize": "1.4rem",
      "lineHeight": "1.1",
      "letterSpacing": "0.028000000000000004rem",
      "fontWeight": "400"
    }, themeStyle.text]}>{value}</_StyledP>
    </_StyledLi>;
}
type Props = {
  mode?: string | null;
  theme?: string | null;
  products: HardwareComparisonProduct[];
  rows: HardwareComparisonRow[];
  hasHighlightDifferencesToggle?: boolean | null;
};
export function HardwareComparisonTableMobile(props: Props) {
  const {
    mode = "light",
    theme = "white",
    products,
    rows
  } = props;
  const themeStyle = getThemeStyle({
    mode: mode as Mode,
    theme: theme as Theme
  });
  const locale = useLocale();
  const [renderFloatingActions, setRenderFloatingActions] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    function handleScroll() {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const {
        top,
        bottom
      } = container.getBoundingClientRect();
      const isVisible = top < window.innerHeight && bottom > 0;
      setRenderFloatingActions(isVisible);
    }
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const defaultAccordionValue = rows[0]?.key ?? "row-0";
  return <div ref={containerRef}>
      {renderFloatingActions && <_StyledDiv $_css2={[{
      "position": "fixed",
      "left": "0",
      "right": "0",
      "bottom": "0",
      "zIndex": "20",
      "borderTopWidth": "1px",
      "padding": "1.6rem"
    }, themeStyle.background, themeStyle.border]}>
          <_StyledDiv2>
            <Button as={Link} fullWidth href="@request-quote-rev8" variant="secondary" icon={ArrowRight}>
              {translations["requestQuote"][locale]}
            </Button>
          </_StyledDiv2>
        </_StyledDiv>}

      <_StyledRadixAccordionRoot defaultValue={defaultAccordionValue} collapsible type="single" $_css3={[{
      "> :not([hidden]) ~ :not([hidden])": {
        "--tw-divide-y-reverse": "0",
        "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
        "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
      }
    }, themeStyle.border]}>
        {rows.map((row, i) => {
        const rowValue = row.key ?? `row-${i}`;
        const IconComponent = row.icon ? specIcons[row.icon] : undefined;
        return <React.Fragment key={rowValue}>
              {i === 5 && <_StyledDiv3 />}
              <_StyledRadixAccordionItem value={rowValue} $_css4={[{
            "position": "relative",
            "zIndex": "10"
          }, themeStyle.background]}>
                <RadixAccordion.Header>
                  <_StyledRadixAccordionTrigger $_css5={[{
                "position": "relative",
                "display": "flex",
                "height": "5.6rem",
                "width": "100%",
                "alignItems": "center",
                "columnGap": "1.6rem",
                "paddingLeft": "1.6rem",
                "paddingRight": "1.6rem",
                "textAlign": "left",
                "&[data-state='open'] [ data-icon]": {
                  "--tw-rotate": "-180deg",
                  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
                  "--tw-text-opacity": "1",
                  "color": "rgb(75 46 248 / var(--tw-text-opacity))"
                },
                "&[data-state='open'] [ data-indicator]": {
                  "display": "block"
                }
              }, themeStyle.text]}>
                    <_StyledDiv4 data-indicator />
                    {row.customIcon ? <_StyledSpan>
                        <Asset asset={row.customIcon as AssetProps["asset"]} imageProps={{
                    width: 24,
                    ratio: "1/1"
                  }} />
                      </_StyledSpan> : IconComponent ? <Icon icon={IconComponent} size="24" /> : null}
                    <_StyledP2>{row.label}</_StyledP2>
                    <_StyledIcon icon={CaretDown} data-icon />
                  </_StyledRadixAccordionTrigger>
                </RadixAccordion.Header>
                <_StyledRadixAccordionContent $_css6={[{
              "overflow": "hidden",
              "@keyframes radix-accordion-collapse-keyframes": {
                "from": {
                  "height": "var(--radix-accordion-content-height)"
                },
                "to": {
                  "height": "0"
                }
              },
              "&[data-state=\"closed\"]": {
                "animation": "radix-accordion-collapse-keyframes 250ms ease-in-out"
              },
              "@keyframes radix-accordion-expand-keyframes": {
                "from": {
                  "height": "0"
                },
                "to": {
                  "height": "var(--radix-accordion-content-height)"
                }
              },
              "&[data-state=\"open\"]": {
                "animation": "radix-accordion-expand-keyframes 250ms ease-in-out"
              }
            }]}>
                  <_StyledUl $_css7={[{
                "> :not([hidden]) ~ :not([hidden])": {
                  "--tw-divide-y-reverse": "0",
                  "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
                  "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
                },
                "borderTopWidth": "1px"
              }, themeStyle.border]}>
                    {products.map(product => <ProductLine key={product.id} product={product} mode={mode as Mode} theme={theme as Theme} rowKey={row.key} />)}
                  </_StyledUl>
                </_StyledRadixAccordionContent>
              </_StyledRadixAccordionItem>
            </React.Fragment>;
      })}

        <_StyledDiv5 />

        <_StyledRadixAccordionItem2 value="download" $_css8={[{
        "position": "relative",
        "zIndex": "10"
      }, themeStyle.background]}>
          <RadixAccordion.Header>
            <_StyledRadixAccordionTrigger2>
              <_StyledDiv6 data-indicator />
              <_StyledP3>{translations["downloadSpecs"][locale]}</_StyledP3>
              <_StyledIcon2 icon={CaretDown} data-icon />
            </_StyledRadixAccordionTrigger2>
          </RadixAccordion.Header>
          <_StyledRadixAccordionContent2 $_css9={[{
          "overflow": "hidden",
          "@keyframes radix-accordion-collapse-keyframes": {
            "from": {
              "height": "var(--radix-accordion-content-height)"
            },
            "to": {
              "height": "0"
            }
          },
          "&[data-state=\"closed\"]": {
            "animation": "radix-accordion-collapse-keyframes 250ms ease-in-out"
          },
          "@keyframes radix-accordion-expand-keyframes": {
            "from": {
              "height": "0"
            },
            "to": {
              "height": "var(--radix-accordion-content-height)"
            }
          },
          "&[data-state=\"open\"]": {
            "animation": "radix-accordion-expand-keyframes 250ms ease-in-out"
          }
        }]}>
            <_StyledUl2 $_css10={[{
            "> :not([hidden]) ~ :not([hidden])": {
              "--tw-divide-y-reverse": "0",
              "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
              "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
            },
            "borderTopWidth": "1px"
          }, themeStyle.border]}>
              {products.map(product => <_StyledLi2 key={product.id}>
                  <_StyledAsset2 asset={product.productImage as AssetProps["asset"]} imageProps={{
                width: 100,
                ratio: "1/1"
              }} />
                  <h3>{product.title}</h3>
                  {product.downloadSpecsLink && <_StyledDiv7>
                      <Button as={Link} href={product.downloadSpecsLink} newWindow variant="underline" icon={Download}>
                        {translations["download"][locale]}
                      </Button>
                    </_StyledDiv7>}
                </_StyledLi2>)}
            </_StyledUl2>
          </_StyledRadixAccordionContent2>
        </_StyledRadixAccordionItem2>

        <_StyledDiv8 />
      </_StyledRadixAccordionRoot>
    </div>;
}
var _StyledLi = _styled("li").withConfig({
  componentId: "sc-sf-1p7ty2b-0"
})({
  "display": "flex",
  "height": "8rem",
  "alignItems": "center",
  "columnGap": "1.6rem",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem"
});
var _StyledAsset = _styled2(Asset).withConfig({
  componentId: "sc-sf-1p7ty2b-1"
})({
  "height": "4.8rem",
  "width": "4.8rem"
});
var _StyledP = _styled3("p").withConfig({
  componentId: "sc-sf-1p7ty2b-2"
})`${p => p.$_css}`;
var _StyledDiv = _styled4("div").withConfig({
  componentId: "sc-sf-1p7ty2b-3"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled5("div").withConfig({
  componentId: "sc-sf-1p7ty2b-4"
})({
  "flex": "1 1 0%"
});
var _StyledRadixAccordionRoot = _styled6(RadixAccordion.Root).withConfig({
  componentId: "sc-sf-1p7ty2b-5"
})`${p => p.$_css3}`;
var _StyledDiv3 = _styled7("div").withConfig({
  componentId: "sc-sf-1p7ty2b-6"
})({
  "height": "4rem"
});
var _StyledRadixAccordionItem = _styled8(RadixAccordion.Item).withConfig({
  componentId: "sc-sf-1p7ty2b-7"
})`${p => p.$_css4}`;
var _StyledRadixAccordionTrigger = _styled9(RadixAccordion.Trigger).withConfig({
  componentId: "sc-sf-1p7ty2b-8"
})`${p => p.$_css5}`;
var _StyledDiv4 = _styled10("div").withConfig({
  componentId: "sc-sf-1p7ty2b-9"
})({
  "position": "absolute",
  "left": "0",
  "right": "0",
  "top": "0",
  "display": "none",
  "height": "0.2rem",
  "--tw-translate-y": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
});
var _StyledSpan = _styled11("span").withConfig({
  componentId: "sc-sf-1p7ty2b-10"
})({
  "height": "2.4rem",
  "width": "2.4rem",
  "flexShrink": "0"
});
var _StyledP2 = _styled12("p").withConfig({
  componentId: "sc-sf-1p7ty2b-11"
})({
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400"
});
var _StyledIcon = _styled13(Icon).withConfig({
  componentId: "sc-sf-1p7ty2b-12"
})({
  "marginLeft": "auto",
  "transitionProperty": "transform",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out"
});
var _StyledRadixAccordionContent = _styled14(RadixAccordion.Content).withConfig({
  componentId: "sc-sf-1p7ty2b-13"
})`${p => p.$_css6}`;
var _StyledUl = _styled15("ul").withConfig({
  componentId: "sc-sf-1p7ty2b-14"
})`${p => p.$_css7}`;
var _StyledDiv5 = _styled16("div").withConfig({
  componentId: "sc-sf-1p7ty2b-15"
})({
  "height": "4rem"
});
var _StyledRadixAccordionItem2 = _styled17(RadixAccordion.Item).withConfig({
  componentId: "sc-sf-1p7ty2b-16"
})`${p => p.$_css8}`;
var _StyledRadixAccordionTrigger2 = _styled18(RadixAccordion.Trigger).withConfig({
  componentId: "sc-sf-1p7ty2b-17"
})({
  "position": "relative",
  "display": "flex",
  "height": "5.6rem",
  "width": "100%",
  "alignItems": "center",
  "columnGap": "1.6rem",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem",
  "textAlign": "left",
  "&[data-state='open'] [ data-icon]": {
    "--tw-rotate": "-180deg",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "--tw-text-opacity": "1",
    "color": "rgb(75 46 248 / var(--tw-text-opacity))"
  },
  "&[data-state='open'] [ data-indicator]": {
    "display": "block"
  }
});
var _StyledDiv6 = _styled19("div").withConfig({
  componentId: "sc-sf-1p7ty2b-18"
})({
  "position": "absolute",
  "left": "0",
  "right": "0",
  "top": "0",
  "display": "none",
  "height": "0.2rem",
  "--tw-translate-y": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
});
var _StyledP3 = _styled20("p").withConfig({
  componentId: "sc-sf-1p7ty2b-19"
})({
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400"
});
var _StyledIcon2 = _styled21(Icon).withConfig({
  componentId: "sc-sf-1p7ty2b-20"
})({
  "marginLeft": "auto",
  "transitionProperty": "transform",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out"
});
var _StyledRadixAccordionContent2 = _styled22(RadixAccordion.Content).withConfig({
  componentId: "sc-sf-1p7ty2b-21"
})`${p => p.$_css9}`;
var _StyledUl2 = _styled23("ul").withConfig({
  componentId: "sc-sf-1p7ty2b-22"
})`${p => p.$_css10}`;
var _StyledLi2 = _styled24("li").withConfig({
  componentId: "sc-sf-1p7ty2b-23"
})({
  "display": "flex",
  "height": "8rem",
  "alignItems": "center",
  "columnGap": "1.6rem",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem"
});
var _StyledAsset2 = _styled25(Asset).withConfig({
  componentId: "sc-sf-1p7ty2b-24"
})({
  "height": "4.8rem",
  "width": "4.8rem"
});
var _StyledDiv7 = _styled26("div").withConfig({
  componentId: "sc-sf-1p7ty2b-25"
})({
  "marginLeft": "auto"
});
var _StyledDiv8 = /*#__PURE__*/_styled27("div").withConfig({
  displayName: "hardware-comparison-table-mobile___StyledDiv8",
  componentId: "sc-134esah-0"
})({
  "height": "4rem"
});